import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { VbFlickityCarouselComponent } from 'rev-shared/ui/flickityCarousel/VbFlickityCarousel.Component';

import { VideoPlaylistCarousel } from './VideoPlaylistCarousel.Component';

const components = [VideoPlaylistCarousel];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		DateAngularModule,
		TooltipModule,
		TranslateModule,
		VbFlickityCarouselComponent
	]
})
export class VideoPlaylistModule {}
